<template>
  <section>
    <Zdialog
      width="90%"
      ref="zdialog"
      :title="'【' + $t('differDetail.diffDetails') + '】' + modalParams.seq"
      zDialogRef="z-dialog1"
      :show.sync="drawerVisible"
      :isConfirmClose="false"
      :isFooter="false"
      :modal="false"
      :hasBodyClass="false"
      :hasMinBtn="false"
      @close="close"
      @minimizeVal="minimizeVal"
      class="stockZdialog">
      <section slot="body" class="content-box"
       v-loading="loading"
       :element-loading-text="$t('differDetail.pleaseWaitLoading')"
       element-loading-spinner="el-icon-loading"
       element-loading-background="rgba(0, 0, 0, 0)">
        <el-descriptions :column="4" border>
          <el-descriptions-item>
            <template slot="label">
              {{$t('differDetail.inventoryOrderName')}}
            </template>
            {{dataInfo.name}}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              {{$t('differDetail.inventoryOrderType')}}
            </template>
            {{dataInfo.typeDesc}}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              {{$t('differDetail.storeName')}}
            </template>
            {{dataInfo.forDeptName}}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              {{$t('differDetail.status')}}
            </template>
            {{dataInfo.stateDesc}}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              {{$t('differDetail.createTime')}}
            </template>
            {{dataInfo.createTime}}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              {{$t('differDetail.completeInventoryTime')}}
            </template>
            {{dataInfo.finishTime}}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              {{$t('differDetail.auditTime')}}
            </template>
            {{dataInfo.reviewTime}}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              {{$t('differDetail.creator')}}
            </template>
            {{dataInfo.createUser}}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              {{$t('differDetail.totalInventoryQuantity')}}
            </template>
            {{dataInfo.inventoryNumber}}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              {{$t('differDetail.totalStockQuantity')}}
            </template>
            {{dataInfo.stockNumber}}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              {{$t('differDetail.totalDiffQuantity')}}
            </template>
            {{dataInfo.differenceNumber}}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              {{$t('differDetail.totalCompensationAmount')}}
            </template>
            {{dataInfo.differencePrice}}
          </el-descriptions-item>
        </el-descriptions>
        <section class="row align-center search-section">
          <div class="row align-center">
            <span style="width: 200px;">{{$t('differDetail.productNo')}}</span>
            <erp-selector
                :placeholder="$t('differDetail.pleaseSelectProductNo')"
                size="mini"
                modelKey="goodsNo"
                type="goodsNo"
                ref="goodsNo"
                v-model="queryParams.goodsNo"
                :multiple="true"
            ></erp-selector>
          </div>
          <el-button class="search-btn" type="primary" size="small" :loading="loading" @click="fetchHadeel">{{$t('differDetail.query')}}</el-button>
        </section>
        <SizeGroupTable
            border
            ref="sizeGroupTableIns"
            height="650px"
            :dataList="dataList"
            :footerOptions="footers"
            :sizeInfoLabels="sizeInfoLabel"
            :columns="columns"
            :isEmpty="true">
        </SizeGroupTable>
        <el-pagination
            layout="total, sizes, prev, pager, next"
            :current-page="page"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="pageSize"
            :total="totalItem"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange">
        </el-pagination>
      </section>
    </Zdialog>
  </section>
</template>

<script>
import Zdialog from '@/components/ZDialog/index.vue'
import erpSelector from '@/components/ErpSelector/index'
import SizeGroupTable from '@/components/SizeGroupTable/index.vue'
import { columns, sizeInfoLabel, footers } from './differDetailConfig'
import {queryDifferDetailInfo, queryDifferDetailList} from "@/libs/http/modules/stock";
export default {
  props: {
    modalParams: {
      type: Object,
      default: () => ({})
    }
  },
  components: {
    Zdialog,
    erpSelector,
    SizeGroupTable
  },
  data() {
    return {
      dataInfo: {},
      loading: false,
      drawerVisible: false,
      queryParams: {
        goodsNo: ''
      },
      columns,
      footers,
      sizeInfoLabel,
      dataList: [],
      page: 1,
      pageSize: 10,
      totalItem: 0
    };
  },
  created() {
    this.drawerVisible = true;
    this.fetchInfo()
    this.queryData()
  },
  methods: {
    close() {
      this.$emit('close', ['close', this.modalParams])
    },
    minimizeVal(e) {
      //是否是最小化，是的话就传给父组件
      if (e) {
        this.$emit('close', ['', this.modalParams])
      }
    },
    isMinimize() {
      this.$refs['zdialog'].minimize()
    },
    fetchInfo(){
      queryDifferDetailInfo({
        recordInfoId: this.modalParams.id
      }).then(res=>{
        this.dataInfo = res
      }).catch(error=>{
        this.$message({type: 'error', message: error, duration: 2000, showClose: true})
      })
    },
    fetchHadeel(){
      this.page = 1
      this.queryData()
    },
    queryData(){
      this.loading = true
      let query = {
        page: this.page,
        pageSize: this.pageSize,
        recordInfoId: this.modalParams.id
      }
      if(this.queryParams.goodsNo && this.queryParams.goodsNo.length){
        query['goodsNo'] = this.queryParams.goodsNo.join(' ')
      }
      queryDifferDetailList(query).then(res=>{
        this.dataList = res.items
        this.totalItem = Number(res.totalItem)
        this.loading = false
      }).catch(error=>{
        this.loading = false
        this.$message({type: 'error', message: error, duration: 2000, showClose: true})
      })
    },
    handleSizeChange(e){
      this.pageSize = e
      this.queryData()
    },
    handleCurrentChange(e){
      this.page = e
      this.queryData()
    },
  },
};
</script>

<style lang="scss" scoped>
.content-box{
  margin: 20px;
}
.search-section{
  margin: 20px 0;
  span{
    width: 40px;
  }
  .search-btn{
    margin-left: 20px;
  }
}
</style>